module.exports = __webpack_public_path__ + "static/img/5.d3f9255b.png";